import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SubmitButton',
  props: {
  type: {
    type: String,
    default: 'submit',
  },
  variant: {
    type: String,
    default: 'primary',
  },
  size: {
    type: String,
    default: 'lg',
  },
  classes: {
    type: String,
    default: 'w-sm-100 text-uppercase',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return { __sfc: true, }
}

})